import httpClient from "../../utilities/http-client";
import { assertAuthSuccessResponse } from "../../utilities/auth-api-response";
import { IConfirmEmailRequest, ILoggedOutModel, ILoginRequest, ILoginResponse, IRegisterRequest, IRegisterResponse, IAcceptRejectRequest, IRequestResetPassword, IRequestUpdatePassword, IRegisterCompnyModel } from "../../models/authmodels";

export const login = async (email: string, password: string, returnUrl: string, rememberMe: boolean): Promise<ILoginResponse> => {
	const body: ILoginRequest = {
		email,
		password,
		returnUrl,
		rememberMe
	};
	const { data } = await httpClient.post<ILoginResponse>("/authenticate/login", body);
	assertAuthSuccessResponse(data, "Errore durante il login");
	return data;
};

export const logout = async (logoutId: string) => {
	try {
		const { data } = await httpClient.post<ILoggedOutModel>("/authenticate/logout", { logoutId });
		return data;
	} catch (e: any) {
		throw e;
	}
};

export const associationsList = async () => {
	try {
		const { data } = await httpClient.get("/associations/list");
		return data;
	} catch (e: any) {
		throw e?.message || e || "exception during request associations list";
	}
}

export const nationsList = async () => {
	try {
		const { data } = await httpClient.get("/nations/list");
		return data;
	} catch (e: any) {
		throw e?.message || e || "exception during request associations list";
	}
}

export const register = async (model: IRegisterRequest): Promise<IRegisterResponse> => {
	const { data } = await httpClient.post<IRegisterResponse>("/authenticate/register", model);
	assertAuthSuccessResponse(data, "Errore durante la registrazione. Riprova più tardi.");
	return data;
};

export const registerCompany = async (model:IRegisterCompnyModel) => {
	try {
		const { data } = await httpClient.post("/authenticate/register-company", model);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const confirmEmail = async (model:IConfirmEmailRequest) => {
	try {
		const { data } = await httpClient.post("/authenticate/confirm", model);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const acceptRejectUser = async (model:IAcceptRejectRequest) => {
	try {
		const { data } = await httpClient.post("/associations/confirmuser", model);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const requestResetPasswordLink = async (model:IRequestResetPassword) => {
	try {
		const { data } = await httpClient.post("/authenticate/password/reset", model);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const updatePassword = async (model:IRequestUpdatePassword) => {
	try {
		const { data } = await httpClient.post("/authenticate/password/update", model);
		return data;
	} catch (e: any) {
		throw  e;
	}
};